import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "architect";

export type ArchitectChatResponse = AgentChatResponse;

export async function createArchitectSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingArchitectSession(
  sessionId: string,
): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamArchitectMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<ArchitectChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Architect agent error",
  );
}
